import { Card, Col, FormGroup, Row, Table } from 'reactstrap';
import MostrarValor from 'views/components/MostrarValor';
import { iAcessoPrograma, iPropostaDados } from '../..';

export default function Cabecalho({
  propostaVersao,
  isModoSimulacao,
  onChange,
  acessoPrograma,
}: {
  propostaVersao: iPropostaDados;
  acessoPrograma: iAcessoPrograma;
  isModoSimulacao: boolean;
  onChange: (a: iPropostaDados) => void;
}): JSX.Element {
  return (
    <Card className="shadow p-3">
      <Row className="px-2">
        <Col sm="4">
          <FormGroup className="pt-2 mb-0">
            <Table>
              <tbody>
                <MostrarValor
                  label="Valor final"
                  valor={propostaVersao.valores.valorFinalComOutros}
                  isDestacado
                />
                {propostaVersao.isExterior && (
                  <MostrarValor
                    label="Valor em Dólar"
                    isDolar
                    valor={propostaVersao.valores.valorFinalDolar}
                    isDestacado={false}
                  />
                )}
              </tbody>
            </Table>
          </FormGroup>
        </Col>
      </Row>
    </Card>
  );
}
